'use client'

import { setLocalLocation } from '@/lib/actions/global/set-local-location'
import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'
import { useRouter } from 'next/navigation'
import React from 'react'

import { AvatarCard, AvatarCardSkeleton } from '@/components/ui/avatar-card'

interface BranchCardListProps extends React.ComponentPropsWithoutRef<'div'> {
  list: any[]
}

const variants = {
  animate: {
    opacity: 1,
    marginTop: 0,
    transition: {
      staggerChildren: 0.1,
    },
  },
}

export const BranchCardList = ({ list, className }: BranchCardListProps) => {
  const router = useRouter()
  const [isLoading, setIsLoading] = React.useState(false)

  return (
    <motion.div
      variants={variants}
      animate="animate"
      className={cn('p-1', className)}
    >
      {(list || [])?.map((location) => {
        return (
          <AvatarCard
            actionLabel="Select"
            className="mt-2 cursor-pointer opacity-0"
            key={location?.id}
            label={location?.name}
            shortCode={location?.code?.substring(0, 2)}
            variants={variants}
            isLoading={isLoading === location?.id}
            disabled={isLoading}
            onClick={async () => {
              setIsLoading(location?.id)
              localStorage?.setItem(
                'smsReceipt',
                location?.location_settings?.receipt?.sms_receipt,
              )
              localStorage?.setItem(
                'emailReceipt',
                location?.location_settings?.receipt?.email_receipt,
              )
              await setLocalLocation(location)
              router.push(`/onboard/${location?.id}`)
            }}
          />
        )
      })}
    </motion.div>
  )
}

export const BranchCardListSkeleton = () => {
  return (
    <motion.div
      variants={variants}
      animate="animate"
      className="flex w-full flex-col gap-2 py-8 opacity-100 md:px-4"
    >
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
      <AvatarCardSkeleton variants={variants} className="opacity-100" />
    </motion.div>
  )
}
